
import Datepicker from 'vuejs-datepicker';
import TimeViewComponent from '@/components/TimeViewComponent.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import StoreModules from '../store/store-modules';
import SummaryPartial from './appointment/SummaryPartial.vue';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import Component from 'vue-class-component';
import Vue from 'vue';
import { en, de } from 'vuejs-datepicker/dist/locale';
import checkPrivacyPolicy from '@/js/check-privacy-policy';
import { Watch } from 'vue-property-decorator';

const MOSPARO_HOST = 'https://mosparo2.ipro.de';
const MOSPARO_PROJECT_ID = 'b822b91d-e081-41ab-858a-8206cca7c075';
const VALID_SALUTATIONS = ['0', '1', '2', '3'];

// A list with countries that are rendered on top of the Phone input.
const PREFERRED_COUNTRIES = ['de', 'dk', 'pl', 'cz', 'at', 'ch', 'fr', 'lu', 'be', 'nl', 'it'];

@Component({
  name: 'MainView',
  metaInfo: {
    title: 'Appointment',
    link: [
      { rel: 'stylesheet', href: `${MOSPARO_HOST}/resources/${MOSPARO_PROJECT_ID}.css` }
    ],
    script: [{ src: `${MOSPARO_HOST}/build/mosparo-frontend.js`, defer: true }]
  },
  components: {
    SummaryPartial,
    Datepicker,
    TimeViewComponent,
    VueHcaptcha
  },
  computed: {
    ...mapGetters(StoreModules.CUSTOMER, [
      'companyInformation',
      'companyId',
      'slug',
      'holidays',
      'activities',
      'branches',
      'employees',
      'roomAv',
      'employeeAv',
      'acBranches'
    ]),
    ...mapGetters({ appointmentLoading: 'appointment/isLoading' }),
    ...mapGetters({ emptyDays: 'appointment/disabledDates' })
  },
  methods: {
    ...mapActions(StoreModules.CUSTOMER, [
      'parseSlug',
      'loadActivities',
      'loadBranches',
      'loadHolidays',
      'loadBranchActivityEmployees',
      'loadRoomEmployeeTimes'
    ]),
    ...mapActions(StoreModules.APPOINTMENT, ['cacheAppointmentsForMonth']),
    ...mapMutations(StoreModules.APPOINTMENT, ['setEmployeeAv', 'setRoomAv', 'setDisabledDatesForMonth', 'resetMonthDates'])
  }
})
export default class MainView extends Vue {
  public companyInformation!: any;
  public companyId!: string | number;
  public slug!: string;
  public holidays!: any[] | null;
  public activities!: string[] | null;
  public branches!: any[];
  public employees!: any[];
  public roomAv!: []; // @TODO: doesn't exist in the Customer store.
  public employeeAv!: any;
  public acBranches!: string[];

  public appointmentLoading!: boolean;
  public emptyDays!: object;

  public parseSlug!: (slug: string) => Promise<void>;
  public loadActivities!: () => {};
  public loadBranches!: () => {};
  public loadHolidays!: () => {};
  public loadBranchActivityEmployees!: (activityData: object) => {};
  public loadRoomEmployeeTimes!: () => {};
  public cacheAppointmentsForMonth!: (data: object) => {};
  public setEmployeeAv!: (availability: any) => {};
  public setRoomAv!: (availability: any) => {};
  public setDisabledDatesForMonth!: (dates: object) => {};
  public resetMonthDates!: () => {};

  public hToken: string | null = null;
  public showMap = false;
  public disabledDate = new Date();
  public currentMonth = 0;
  public currentYear = 0;
  public filteredEmployees: any[] = [];
  public selectedActivity: any = {};
  public selectedEmployee = {};
  public selectedBranch: any = {};
  public selectedDate = new Date();
  public level = 0;
  public privacyAccepted = false;
  public AGBAccepted = false;
  public loading = true;
  public loadingSteps = 0;
  public formInputValid = false;
  public sendButtonWasTapped = false;
  public summaryButtonWasTapped = false;
  public requestSending = false;
  public noAccessURL = process.env.VUE_APP_NOACCESSURL;
  public captchaValid = false;
  public loadingTimes = false;
  public datePickerState: {
    disabled: {
      from: object,
      to: object|null,
      days: Array<any>,
      dates: Array<any>
    }
  } = {
      disabled: {
        from: {},
        to: {},
        days: [],
        dates: []
      }
    };

  public dobDatePickerState = {
    disabled: {
      from: new Date()
    }
  };

  public InputErrorMsg = '';
  public showHeadActivity = true;
  public showHeadBranch = true;
  public showHeadEmployee = true;
  public userData: {
    Sex?: number,
    EmployeeID: number | null,
    ActivityID: number | null,
    BranchID: number | null,
    Name: string,
    Vorname: string,
    DOB: string | undefined,
    Phone: string,
    Remarks: string,
    Email: string,
    CompanyID: string,
    RoomID: string,
    Date: string,
    assignEmployeeID: string
  } = {
      Sex: undefined,
      EmployeeID: null,
      ActivityID: null,
      BranchID: null,
      Name: '',
      Vorname: '',
      DOB: undefined,
      Phone: '',
      Remarks: '',
      Email: '',
      CompanyID: '',
      RoomID: '',
      Date: '',
      assignEmployeeID: ''
    };

  public levelHistory:Array<Number> = [];
  public showPPLink: boolean = false;

  private mosparoSubmitToken = '';
  private mosparoValidationToken = '';
  public showValidationMessage = false;

  public preferredCountries = PREFERRED_COUNTRIES;
  public isPhoneInputFocused = false;

  async mounted () {
    const otevurl = this.$route.params.otevurl;

    if (otevurl && !this.companyInformation && otevurl !== this.slug) {
      await this.parseSlug(otevurl);
    }

    await this.onLoad();
  }

  get hSiteKey () {
    return process.env.VUE_APP_SITE_KEY;
  }

  get urlBackLink () {
    let protocol = '';
    if (!this.companyInformation.URLBackLink.includes('http')) {
      protocol = 'https://';
    }
    return protocol + this.companyInformation.URLBackLink;
  }

  get filteredBranches () {
    return this.branches ? this.branches.filter((el: any) => this.acBranches.includes(el.BranchID)) : [];
  }

  get mapsUrl () {
    return (
      this.companyInformation.IframURL ||
      'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
        encodeURIComponent(this.selectedBranch.BranchAddress)
    );
  }

  get ppUrl () {
    return this.companyInformation.URLGDPR && this.companyInformation.URLGDPR !== ''
      ? this.companyInformation.URLGDPR
      : 'https://www.click2date.eu/OTeV/userdata/images/' +
          this.companyId +
          '/' +
          this.companyId +
          '-privacypolicy.pdf';
  }

  get logoUrl () {
    return '/OTeV/userdata/images/' + this.companyId + '/' + this.companyId + '-Logo.jpg';
  }

  get canGoBack () {
    // Activate backward navigation starting from the 2nd page.
    return this.level > 0 && !this.sendButtonWasTapped;
  }

  get datepickerLanguage () {
    const browserLanguage = navigator.language.slice(0, 2);
    return browserLanguage === 'de' ? de : en;
  }

  /**
   * Show confirmation button only if there is Tracking URL.
   *
   * Skip checking homepage path.
   */
  get completeProcessURL () {
    const protocol = !this.companyInformation.URLTrackingLink.includes('http')
      ? 'https://'
      : '';
    return protocol + this.companyInformation.URLTrackingLink;
  }

  get showCalendarIcon (): boolean {
    return !!this.companyInformation.ShowCalendarIcon;
  }

  get canSubmitForm (): boolean {
    return !!this.mosparoSubmitToken && !!this.mosparoValidationToken;
  }

  get companyLogoAltText (): string {
    return `${this.companyInformation.CompanyName} logo`;
  }

  async onChangeMonth (obj: any) {
    // Check if the parameter has "timestamp" property as callback gets different
    // input while selecting a day and while switching a month.
    let selectedDate = obj;
    if (obj.timestamp) {
      selectedDate = new Date(obj.timestamp);
    }

    this.currentMonth = selectedDate.getMonth() + 1;
    this.currentYear = selectedDate.getFullYear();
    await this.formDataForMonthCache();
    this.preSetupDatePicker(false);
    this.setDisabledDatesForMonth({ year: selectedDate.getFullYear(), month: selectedDate.getMonth(), companyInformation: this.companyInformation, duration: this.selectedActivity.Duration });
    this.datePickerState.disabled.dates = [...this.datePickerState.disabled.dates, ...(this.emptyDays as [])];
  }

  onVerify (token: string) {
    this.hToken = token;
  }

  disabledDateSelected (date: any) {}

  async onLoad () {
    document.documentElement.style.setProperty('--company-color', this.companyInformation.ColorHex);
    document.documentElement.style.setProperty('--head-color', this.companyInformation.HeadColor);
    document.documentElement.style.setProperty('--background-color', this.companyInformation.BackgroundColor ?? 'white');
    document.documentElement.style.setProperty('--border-color', this.companyInformation.BorderColor ?? '#f1f1f1');
    document.documentElement.style.setProperty('--font-color', this.companyInformation.FontColor ?? '#2c3e50');

    // eslint-disable-next-line no-extend-native
    Date.prototype.addDays = function (days: any) {
      const dat = new Date(this.valueOf());
      dat.setDate(dat.getDate() + days);
      return dat;
    };

    await this.loadHolidays();
    this.preSetupDatePicker();
    this.loadingSteps++;
    await this.loadActivities();
    this.loadingSteps++;
    await this.loadBranches();
    this.loadingSteps++;
    this.loading = false;

    await this.checkForURLQuery();

    checkPrivacyPolicy.privacyPolicyExists(this.companyInformation).then((privacyPolicyExists) => { this.showPPLink = privacyPolicyExists; });
  }

  preSetupDatePicker (resetSelectedDate = true) {
    this.datePickerState.disabled.dates = [];
    for (let i = 0; i < (this.holidays ?? []).length; i++) {
      if (this.holidays && this.holidays[i]) {
        const d = this.holidays[i];
        const dd = new Date(d.HolidayDate);
        this.datePickerState.disabled.dates.push(dd);
      }
    }

    const dayOffset = this.companyInformation.DayOffset || this.companyInformation.dayOffset;

    let a = 1;
    const dOffset = parseInt(dayOffset.replace('+', '').replace('d', ''));

    let dat = new Date();
    dat = dat.addDays(parseInt(dayOffset.replace('+', '').replace('d', '')));

    a += dOffset;
    const startDate = new Date(this.selectedDate.getTime()).addDays(a);
    // Shift forward selected date if it falls on a holiday. Use holidays after
    // the selected date and walk through all of them. Such approach properly handles case
    // when multiple holidays go one by one in a row.
    this.datePickerState.disabled.dates
      .filter(disabledDate => disabledDate.setHours(0, 0, 0, 0) >= startDate.setHours(0, 0, 0, 0))
      .forEach((disabledDay: Date) => {
        if (disabledDay.toDateString() === startDate.toDateString()) {
          a++;
        }
      });

    if (resetSelectedDate) { this.selectedDate = this.disabledDate.addDays(a); }

    this.currentMonth = this.selectedDate.getMonth() + 1;
    this.currentYear = this.selectedDate.getFullYear();
    this.disabledDate = dat;

    const fromDate = new Date();
    fromDate.setMonth(fromDate.getMonth() + parseInt(this.companyInformation.MonthsAhead));

    this.datePickerState.disabled.to = dat;
    this.datePickerState.disabled.from = fromDate;
  }

  async formDataForMonthCache () {
    const formData = new FormData();
    formData.append('employeeId', (this.userData.EmployeeID ?? '').toString());
    formData.append('activityId', (this.userData.ActivityID ?? '').toString());
    formData.append('companyId', this.companyId.toString());
    formData.append('branchId', (this.userData.BranchID ?? '').toString());
    return this.cacheAppointmentsForMonth({ formData, month: this.currentMonth, year: this.currentYear });
  }

  imageErrorLoad (err: any) {
    err.target.style.display = 'none';
  }

  validateFormInputs () {
    if (!VALID_SALUTATIONS.includes((this.userData.Sex ?? '').toString())) {
      this.InputErrorMsg = this.$translations.InputErrorMsgSalutation;
      return false;
    }

    if (!this.userData.Name) {
      this.InputErrorMsg = this.$translations.InputErrorMsgLastname;
      return false;
    }

    if (!this.userData.Vorname) {
      this.InputErrorMsg = this.$translations.InputErrorMsgFirstname;
      return false;
    }

    // eslint-disable-next-line no-useless-escape
    if (!/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.userData.Email)) {
      this.InputErrorMsg = this.$translations.InputErrorMsgEmail;
      return false;
    }

    if (!this.userData.DOB && this.companyInformation.fieldDOBmandatory) {
      this.InputErrorMsg = this.$translations.InputErrorMsgDOB;
      return false;
    }

    if (this.companyInformation.fieldMobilemandatory) {
      if (!this.userData.Phone || this.userData.Phone.length < 8) {
        this.InputErrorMsg = this.$translations.InputErrorMsgMobile;
        return false;
      }
    }

    if (!this.userData.Phone) {
      this.userData.Phone = '';
    }

    if (!this.userData.Remarks) {
      this.userData.Remarks = '';
    }

    return true;
  }

  isSalutationValid () {
    return this.summaryButtonWasTapped
      ? VALID_SALUTATIONS.includes((this.userData.Sex ?? '').toString()) ? null : false
      : null;
  }

  isNameValid () {
    return this.summaryButtonWasTapped
      ? this.userData.Name ? null : false
      : null;
  }

  isVornameValid () {
    return this.summaryButtonWasTapped
      ? this.userData.Vorname ? null : false
      : null;
  }

  isEmailValid () {
    return this.summaryButtonWasTapped
      // eslint-disable-next-line no-useless-escape
      ? /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.userData.Email) ? null : false
      : null;
  }

  isBirthdayValid () {
    return this.summaryButtonWasTapped
      ? this.userData.DOB || !this.companyInformation.fieldDOBmandatory ? null : false
      : null;
  }

  isMobileValid () {
    if (!this.companyInformation.fieldMobilemandatory) {
      return null;
    }

    return this.summaryButtonWasTapped
      ? this.userData.Phone && this.userData.Phone.length >= 8 ? null : false
      : null;
  }

  async activityButtonTapped (ac: any) {
    this.userData.CompanyID = this.companyId.toString();
    this.selectedActivity = ac;
    this.userData.ActivityID = parseInt(ac.ActivityID);
    await this.$store.dispatch('customer/loadBranchesByActivity', ac.ActivityID);
    if (this.userData.ActivityID) {
      if (this.branches.length > 1) {
        this.level++;
        this.levelHistory.push(this.level);
        if (this.userData.BranchID) {
          this.branchButtonTapped({ BranchID: this.userData.BranchID });
        }
      } else {
        this.level++;
        this.levelHistory.push(this.level);
        this.branchButtonTapped(
          { BranchID: this.branches[0].BranchID }
        );
      }
    }
  }

  async loadEmployeeActivities () {
    await this.loadBranchActivityEmployees({
      activityId: this.userData.ActivityID,
      branchId: this.userData.BranchID
    });
    this.filteredEmployees = [];

    this.employees.forEach((element: any) => {
      let exists = false;

      this.filteredEmployees.forEach((element1: any) => {
        if (parseInt(element1.EmployeeID) === parseInt(element.EmployeeID)) exists = true;
      });

      if (parseInt(element.ActivityID) === parseInt((this.userData.ActivityID ?? '').toString())) {
        if (!exists) this.filteredEmployees.push(element);
      }
    });
    this.filteredEmployees.forEach((element) => {
      if (parseInt(element.EmployeeID) === parseInt((this.userData.EmployeeID ?? '').toString())) {
        this.selectedEmployee = element;
        this.formDataForMonthCache().then(() => {
          this.dateSelected(this.selectedDate);
        });
      }
    });
  }

  async branchButtonTapped (branch: any) {
    const bId = branch.BranchID;
    this.userData.BranchID = bId;
    this.branches.forEach((element) => {
      if (parseInt(element.BranchID) === parseInt(bId)) {
        this.selectedBranch = element;
      }
    });

    await this.loadEmployeeActivities();

    if (this.userData.BranchID) {
      if (this.companyInformation.ShowEmployee === '0') {
        this.userData.EmployeeID = 0;

        this.filteredEmployees.forEach((element) => {
          if (element.EmployeeID === this.userData.EmployeeID) {
            this.selectedEmployee = element;
          }
        });
        this.level += 2;
        this.levelHistory.push(this.level);
        this.resetMonthDates();
        this.formDataForMonthCache().then(() => {
          this.dateSelected(this.selectedDate);
        });
      } else {
        this.level++;
      }
    }
  }

  async personButtonTapped (person: any) {
    this.userData.EmployeeID = parseInt(person.EmployeeID);
    this.selectedEmployee = person;
    this.resetMonthDates();
    if (this.userData.EmployeeID >= 0) {
      this.formDataForMonthCache().then(() => {
        this.dateSelected(this.selectedDate);
      });
      this.level++;
      this.levelHistory.push(this.level);
    }
  }

  async dateSelected (d: Date) {
    this.selectedDate = new Date(d);
    this.setRoomAv({ day: d.getDate(), month: d.getMonth(), year: d.getFullYear() });
    this.setEmployeeAv({ day: d.getDate(), month: d.getMonth(), year: d.getFullYear() });
    this.preSetupDatePicker(false);
    this.setDisabledDatesForMonth({ year: d.getFullYear(), month: d.getMonth(), companyInformation: this.companyInformation, duration: this.selectedActivity.Duration });

    this.datePickerState.disabled.dates = [...this.datePickerState.disabled.dates, ...(this.emptyDays as [])];
  }

  timeItemClicked (e: any) {
    this.userData.RoomID = e.RoomID;
    this.userData.Date = e.Date;
    this.userData.assignEmployeeID = e.EmployeeID;
    this.level++;
    this.levelHistory.push(this.level);
  }

  private setMosparoTokens (): void {
    // The fields are generated by dynamically loaded Mosparo JavaScript.
    // Find related inputs and retrieve the tokens once the user clicked
    // on Mosparo checkbox.
    const submitTokenElement = document.querySelector<HTMLInputElement>('[name="_mosparo_submitToken"]');
    this.mosparoSubmitToken = submitTokenElement ? submitTokenElement.value : '';

    const validationTokenElement = document.querySelector<HTMLInputElement>('[name="_mosparo_validationToken"]');
    this.mosparoValidationToken = validationTokenElement ? validationTokenElement.value : '';
  }

  public resetMosparoToken (): void {
    this.mosparoSubmitToken = '';
    this.mosparoValidationToken = '';
  }

  @Watch('level')
  public onLevelChange (newLevel: number): void {
    // Track 4th step when the user provides personal data.
    // This form is protected by Mosparo.
    if (newLevel === 4) {
      this.$nextTick(() => {
        // Reset the tokens as its possible to go back to the step with personal data.
        // At this point Mosparo re-renders the box and requires click on the checkbox.
        this.resetMosparoToken();

        // eslint-disable-next-line
        new mosparo(
          'mosparo-box',
          'https://mosparo2.ipro.de',
          'b822b91d-e081-41ab-858a-8206cca7c075',
          'xPL81kb4fNF7umhJwAvLOOnbaKxmSWjrMx6XHUmYLsw',
          { onCheckForm: this.setMosparoTokens }
        );
      });
    }
  }

  summaryButtonClicked () {
    this.summaryButtonWasTapped = true;
    this.formInputValid = this.validateFormInputs();

    if (this.formInputValid) {
      this.level++;
      this.levelHistory.push(this.level);
    }
  }

  sendButtonTapped () {
    if (!this.privacyAccepted || (this.companyInformation.AGBMandatory && !this.AGBAccepted)) return;

    this.userData.DOB = this.userData.DOB
      ? this.$moment(this.userData.DOB).format('YYYY-MM-DD')
      : undefined;
    this.requestSending = true;
    this.formInputValid = this.validateFormInputs();
    if (this.formInputValid) {
      const formData = new FormData();
      formData.append('CompanyID', this.companyId.toString());
      formData.append('BranchID', (this.userData.BranchID ?? '').toString());
      formData.append('LastName', this.userData.Name);
      formData.append('FirstName', this.userData.Vorname);
      formData.append('Sex', (this.userData.Sex ?? '').toString());
      formData.append('Email', this.userData.Email);
      formData.append('Mobile', this.userData.Phone);
      formData.append('Remarks', this.userData.Remarks);
      formData.append('ActivitySelected', (this.userData.ActivityID ?? '').toString());
      formData.append('EmployeeSelected', (this.userData.EmployeeID ?? '').toString());
      formData.append('EmployeeAssigned', this.userData.assignEmployeeID);
      formData.append('RoomAssigned', this.userData.RoomID);
      formData.append('AppStart', this.userData.Date);
      formData.append('AppEnd', this.userData.Date);
      formData.append('SubmitTime', this.$moment());
      formData.append('Duration', this.selectedActivity.Duration);
      formData.append('DOB', this.userData.DOB ?? '');
      // formData.append('hToken', (this.hToken ?? '').toString());

      formData.append('_mosparo_submitToken', this.mosparoSubmitToken);
      formData.append('_mosparo_validationToken', this.mosparoValidationToken);

      this.$http.post(this.noAccessURL + 'submit.php', formData).then(
        (response) => {
          if (response.data && response.data.validationFailed) {
            this.requestSending = false;
            this.showValidationMessage = true;
            return;
          }

          // If URLTrackingLink is filled and TrackInsteadofSummary is 1: In this case,
          // when Submit button is pressed, the summary will not be displayed. Instead,
          // the URLTrackingLink is loaded directly.
          if (this.companyInformation.URLTrackingLink && this.companyInformation.TrackInsteadofSummary) {
            window.location.replace(this.completeProcessURL);
            return;
          }

          this.sendButtonWasTapped = true;
          this.requestSending = false;
        },
        (response) => {
          // error callback
        }
      );
    }
  }

  async tabClicked (e: any) {
    if (!this.sendButtonWasTapped) {
      const id = e.target.id;
      this.level = parseInt(id);
      this.levelHistory.push(this.level);
    }
  }

  async checkForURLQuery () {
    this.userData.CompanyID = this.companyId.toString();
    let loadEmp = false;

    if (this.$route.query.fn) this.userData.Vorname = this.$route.query.fn.toString();

    if (this.$route.query.ln) this.userData.Name = this.$route.query.ln.toString();

    if (this.$route.query.ml) this.userData.Email = this.$route.query.ml.toString();

    if (this.$route.query.db) this.userData.DOB = this.$moment(new Date(this.$route.query.db.toString())).format('YYYY-MM-DD');

    if (this.$route.query.sx) {
      this.userData.Sex = VALID_SALUTATIONS.includes(this.$route.query.sx.toString())
        ? parseInt(this.$route.query.sx.toString())
        : 1;
    }

    if (this.$route.query.ph) this.userData.Phone = this.$route.query.ph.toString();

    if (this.$route.query.ac) {
      const suggestedActivity = parseInt(this.$route.query.ac.toString());
      (this.activities ?? []).forEach((element: any) => {
        if (parseInt(element.ActivityID) === suggestedActivity) {
          this.userData.ActivityID = suggestedActivity;
          this.selectedActivity = element;
        }
      });
    }

    if (this.$route.query.br) {
      const suggestedBranch = parseInt(this.$route.query.br.toString());
      this.branches.forEach((element) => {
        if (parseInt(element.BranchID) === suggestedBranch) {
          this.userData.BranchID = suggestedBranch;
          this.selectedBranch = element;
        }
      });

      if (this.userData.ActivityID) {
        loadEmp = true;
      }
    }

    this.level = 0;
    this.levelHistory.push(this.level);
    if (this.userData.ActivityID) {
      this.showHeadActivity = true;

      let branch = this.branches.length === 1 ? this.branches[0] : null;
      if (!branch && this.branches.length > 1) {
        await this.$store.dispatch('customer/loadBranchesByActivity', this.userData.ActivityID);
        const suggestedBranch = this.$route.query.br
          ? parseInt(this.$route.query.br.toString())
          : null;
        branch = this.filteredBranches.find((branch: any) => parseInt(branch.BranchID) === suggestedBranch);
      }

      if (branch) {
        this.level = 2;
        this.levelHistory.push(this.level);
        this.userData.BranchID = branch.BranchID;
        this.selectedBranch = branch;
        loadEmp = true;
      } else {
        this.level = 1;
        this.levelHistory.push(this.level);
      }
    }
    if (loadEmp || (this.userData.BranchID ?? NaN) >= 0) await this.loadEmployeeActivities();

    if (this.userData.BranchID && this.userData.BranchID >= 0) {
      this.level = 2;
      this.levelHistory.push(this.level);
    }

    if (this.companyInformation.ShowEmployee === '0') {
      this.userData.EmployeeID = 0;
    } else {
      const suggestedEmployee = this.$route.query.em
        ? parseInt(this.$route.query.em.toString())
        : null;
      if (suggestedEmployee || suggestedEmployee === 0) {
        await this.loadEmployeeActivities();
        const userEmployee = this.employees.find((employee: any) => parseInt(employee.EmployeeID) === suggestedEmployee);

        if (userEmployee) {
          this.userData.EmployeeID = userEmployee.EmployeeID;
          this.selectedEmployee = userEmployee;
        }
      }
    }

    if (this.userData.ActivityID && this.userData.ActivityID >= 0 &&
     this.userData.BranchID && this.userData.BranchID >= 0 &&
     this.userData.EmployeeID !== null && !isNaN(parseInt(this.userData.EmployeeID.toString()))) {
      this.level = 3;
      this.levelHistory.push(this.level);
      this.showHeadEmployee = true;
      this.formDataForMonthCache().then(() => {
        this.dateSelected(this.selectedDate);
      });
    }
  }

  inIframe () {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  onBackLevel () {
    if (this.level > 0) {
      this.level--;

      if (this.level === 2 && this.companyInformation.ShowEmployee === '0') {
        this.level--;
      }

      if (this.level === 1 && this.branches.length <= 1) {
        this.level--;
      }
    }
  }

  onBackLevelKeyDown (event: KeyboardEvent) {
    // Handle Enter and Space key presses.
    if (event.key === 'Enter' || event.key === ' ') {
      (event.target as HTMLElement).click();
      event.preventDefault();
    }
  }
}
